import styles from "./Footer.module.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { footerMenuItems, ROUTES_WITHOUT_FOOTER } from "../../constants/structure";
import SideBarIcon from "../sideBar/SideBaricon";
import FooterLogo from "../icons/FooterLogo";
import useWindowSize from "../../hooks/useWindowSize";
import { ROUTES } from "../../constants/routes";
import { useTranslation } from "react-i18next";
import SupportIcon from "../icons/footer/SupprotIcon";
import { useAppSelector } from "../../store/store";

interface IProps {
  source: string;
}
const Footer = ({ source }: IProps) => {
  const currentYear = new Date().getFullYear();
  const { windowSize } = useWindowSize();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const userEmail = useAppSelector((state: any) => state.auth.userData.email);
  const accountFooterRoutes = [
    ROUTES.PROFILE,
    ROUTES.LOGIN,
    ROUTES.MOBILE_PRE_LOGIN,
    ROUTES.MOBILE_ACCOUNT_SETTINGS,
    ROUTES.MOBILE_PAYMENT_DETAILS,
  ];

  const focusHandler = () => {
    const chooseWrapper = document.getElementById("choose_section");

    if (chooseWrapper) {
      chooseWrapper.focus();
    }
  };

  const dirData = i18n.language === "ar" ? "rtl" : "ltr";
  const footerContentHandler = () => {
    if (windowSize !== "mobile" && !ROUTES_WITHOUT_FOOTER.includes(pathname)) {
      return (
        <div
          data-app-footer
          dir={dirData}
          className={`${styles.footerWrapper} ${
            source === "modal" || source === ROUTES.SEARCH ? styles.footerModalWrapper : ""
          }`}
          onClick={focusHandler}
        >
          <Link to={ROUTES.FOR_YOU}>
            <div className={styles.footerLogoWrapper}>
              <FooterLogo />
            </div>
          </Link>

          <div className={styles.links}>
            <Link to={ROUTES.DISCOUNT}>{t("subscriptions")}</Link>
            <Link to={ROUTES.AGREEMENT}>{t("agreement")}</Link>
            <Link to={ROUTES.ABOUT_US}>{t("Aboutus")}</Link>
            <Link to={ROUTES.COOPERATION}>{t("Cooperation")}</Link>
          </div>
          <div dir={dirData} className={styles.copy}>
            <div dir={dirData} className={styles.supportBtn} onClick={() => navigate(ROUTES.SUPPORT)}>
              <SupportIcon />
              {t("Usersupport")}
            </div>
            <a href="/">
              © {currentYear}
              <span>HIVIEWER.</span> {t("copyright")}.
            </a>
          </div>
        </div>
      );
    }

    if (windowSize === "mobile") {
      return (
        <div data-app-footer className={styles.footerWrapperMobile}>
          {footerMenuItems.map((item: any) => {
            const pathHandler = (path: string) => {
              if (path === "profile") {
                return userEmail ? ROUTES.PROFILE : ROUTES.MOBILE_PRE_LOGIN;
              }

              return `/${path}`;
            };

            const selectedItemHandler = () => {
              if (item.path === "profile") {
                return accountFooterRoutes.includes(pathname);
              }
              return pathname === `/${item.path}`;
            };
            return (
              <Link key={item.path} to={pathHandler(item.path)} className={styles.itemWrapper}>
                <SideBarIcon
                  iconName={item.path}
                  selectedItem={selectedItemHandler()}
                  isMobile={windowSize === "mobile"}
                  dataTour={item.path}
                />
              </Link>
            );
          })}
        </div>
      );
    }

    return <div />;
  };

  return footerContentHandler();
};

export default Footer;
